import { ICategory } from '../../../../shared-interfaces/Notation/ICategory';
import { ICoreUser } from '../../../../shared-interfaces/User/ICoreUser';
import { INotation } from '../../../../shared-interfaces/Notation/INotation';
import { NotationType } from '../../../../shared-types/Notation/NotationType';
import dayjs from 'dayjs';
import { AlertStatus } from '../../../../shared-types/Notation/AlertStatus';

export interface INotationManagementFilters {
  createdBy: ICoreUser | undefined;
  createdFor: ICoreUser | undefined;
  assignedTo: ICoreUser | undefined;
  notationTypes: NotationType[];
  alertStatus: AlertStatus[];
  categories: ICategory[];
  startDate: Date | undefined;
  endDate: Date | undefined;
  onlyUnassigned: boolean;
}

export interface INotationManagementState {
  notations: Array<INotation>;
  categories: Array<ICategory>;
  filters: INotationManagementFilters;
  isNotationsLoading: boolean;
  hasMoreNotation: boolean;
  focusedNotation: INotation | undefined;
  modalStatus?:
    | 'LowerAlert'
    | 'ExpandedNotation'
    | 'DeleteConfirmation'
    | 'MassLowerAlert';
  selectedNotations: INotation[];
  excludedNotations: INotation[];
  selectAll: boolean;
  notationsPage: number;
  totalNotations: number;
}

export const notationManagementInitialState = (): INotationManagementState => {
  return {
    categories: [],
    notations: [],
    focusedNotation: {} as INotation,
    isNotationsLoading: false,
    notationsPage: -1,
    hasMoreNotation: false,
    filters: {
      categories: [],
      notationTypes: [
        NotationType.Update,
        NotationType.Alert,
        NotationType.Encouragement,
        NotationType.DataInsight,
      ],
      alertStatus: [AlertStatus.Open, AlertStatus.Lowered],
      startDate: dayjs().startOf('M').subtract(6, 'M').toDate(),
      createdBy: {} as ICoreUser,
      createdFor: {} as ICoreUser,
      assignedTo: {} as ICoreUser,
      endDate: undefined,
      onlyUnassigned: false,
    },
    selectedNotations: [],
    excludedNotations: [],
    selectAll: false,
    totalNotations: -1,
  };
};
